import { render, staticRenderFns } from "./MiniWizardItem.vue?vue&type=template&id=7fe407b2"
import script from "./MiniWizardItem.vue?vue&type=script&lang=js"
export * from "./MiniWizardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports